// extracted by mini-css-extract-plugin
var _1 = "DocFlowSendingTableRow-moduleDocFlowSendingTableRow__eMWla TableComponent-modulerow__xPAo4";
export { _1 as "DocFlowSendingTableRow" }
